export default __webpack_public_path__ + "static/logo-invert-0883cf5220aa8b1bd4ebe5060b22fc4f.svg";